<template>
  <div id="report-page">
    <b-tabs class="custom-tab" v-model="stepActive">
      <b-tab lazy title="Generate Report" :title-link-class="['font-medium-5']">
        <generate-report :isAdjusted="getPermissionModule('Report').adjust" @nextStep="onNextStep" />
      </b-tab>
      <b-tab
        lazy
        :title="'History Report'"
        :title-link-class="['font-medium-5']"
      >
        <history-report :isAdjusted="getPermissionModule('Report').adjust"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import GenerateReport from './generate-report/GenerateReport.vue';
  import HistoryReport from './history-report/HistoryReport.vue';

  import useReport from './hooks/useReport';

  export default {
    components: { GenerateReport, HistoryReport },

    setup() {
      const { stepActive, onNextStep, getPermissionModule } = useReport();

      return { stepActive, onNextStep, getPermissionModule };
    },
  };
</script>

<style scoped>
  @import '~@/assets/css/pages/report/report.css';
  @import '~@/assets/css/override-styles/progress-nav.css';
</style>
